// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de627680","239":"b4b485a3","455":"2f79c54c"}[chunkId] + ".chunk.js";
};